<template>
    <div id="prizes" :style="'background-image:url('+imgPath+'luckdraw/bg3.png)'">
      <img :src="imgPath+'luckdraw/person.png'" class="logo">
      <div class="prize-win-panel">
        <div class="tbbox">
          <table class="prize-win-list" v-if="prizelist">
            <thead>
              <tr><th>奖品</th> <th>兑奖码</th> <th>时间</th></tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in prizelist" :key="index">
                <th>{{item.name}}<!-- <img :src="item.pic_url" :alt="item.name"> --></th>
                <th>{{item.exchange_code}}</th>
                <th>{{item.create_time.split(' ')[1]}}</th>
              </tr>
            </tbody>
          </table>
          <p class="center" v-else><br/>暂无中奖信息</p>
        </div>
        <br/>
        <img :src="imgPath+'luckdraw/main-top.png'" class="main-top">
      </div>
      <div class="way">
        <h3>兑奖方式</h3>
        <img :src="imgPath+'luckdraw/manner_border.png'">
        <p>{{prizeRemark}}</p>
      </div>
    </div>
</template>

<script>
import tool from '../../kits/Tools.js';
    export default {
        data() {
            return {
              imgPath:''
            }
        },
        props:['prizelist','prizeRemark'],
        mounted(){
          this.imgPath = tool.imgPath();
        }
    }
</script>

<style scoped>
.center {
  text-align: center;
}

img {
  max-width: 100%;
}

#prizes {
  height: 100%;
  background-color: rgb(250, 61, 62);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding-top: 30px;
  box-sizing: border-box;
  margin: -10px;
}

.logo {
  margin: 0 auto;
  margin-top: 1rem;
  display: block;
  position: relative;
  top: 3px;
  width: 88%;
}

.prize-win-panel {
  background-color: #FCEFC8;
  margin: 0 auto;
  width: 88%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 30px;
}

.prize-win-list {
  width: 100%;
  text-align: center;
}

.prize-win-list tr {
  line-height: 30px;
}

.prize-win-list thead th {
  color: #fc453a;
  font-size: 16px;
}

.prize-win-list tbody th {
  font-weight: normal;
}

.prize-win-list tbody th img {
  max-width: 40px;
}

.main-top {
  position: absolute;
  bottom: 0;
  max-width: none;
  width: 113%;
  left: -6.5%;
}

h3 {
  text-align: center;
  padding-top: 40px;
  margin-bottom: 10px;
}

.way {
  width: 94%;
  background-color: #fc453a;
  box-shadow: 0 0 33px 3px rgba(0,0,0,0.2);
  margin: 0 auto;
  text-align: center;
  color: #fcefc7;
}

.way img {
  width: 80%;
  margin-bottom: 10px;
}

.way p {
  padding: 0 10px 10px;
}

.tbbox {
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// prizes.vue?566f3414